import React, { useState, useEffect } from 'react';
import axios from 'axios';

const UsersComponent = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  
  useEffect(() => {
    axios.get(`${apiUrl}/api/users`)
      .then((response) => {
        setUsers(response.data);
        setLoading(false);
      })
      .catch((error) => {
        setError(error.message);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>{apiUrl}Error: {error}</div>;
  }

  return (
    <div>
      <h2>Users List</h2>
      <ul className="users-list bg-red-100 p-4 rounded-lg">
        {users.map((user) => (
          <li key={user.id}>
            <strong>{user.name}</strong> - {user.email} - Role: {user.role}
            {user.phone && <span> - Phone: {user.phone}</span>}
            {user.syllabus && <span> - Syllabus: {user.syllabus}</span>}
            {user.grade && <span> - Grade: {user.grade}</span>}
            {user.student_subject && <span> - Subject: {user.student_subject}</span>}
            {user.qualification && <span> - Qualification: {user.qualification}</span>}
            {user.tutor_subject && <span> - Tutor Subject: {user.tutor_subject}</span>}
            {user.experience && <span> - Experience: {user.experience}</span>}
            {user.bio && <p>Bio: {user.bio}</p>}
            {user.profile_image && <img src={user.profile_image} alt="Profile" width="50" />}
            
          </li>
        ))}
      </ul>
    </div>
  );
};

export default UsersComponent;